export function genericRaycast(raycaster, arr){
  let rez = raycaster.intersectObject(this._cube)
  if(rez.length){
    return arr.push({ object: this, distance: rez[0].distance });
  }
}